import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { EditRoadSvg } from './svgs';

export const IconEditRoad: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={EditRoadSvg} viewBox="0 0 24 24" {...props} />;
};
